import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../locales/en.json";
import am from "../locales/am.json";
import { applyLanguage, resolveLanguage } from "../utils/language";

const initialLng = resolveLanguage();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    am: { translation: am },
  },
  lng: initialLng,
  fallbackLng: "en",
  supportedLngs: ["en", "am"],
  interpolation: {
    escapeValue: false,
  },
});

applyLanguage(i18n.language?.split("-")[0] || initialLng);

i18n.on("languageChanged", (lng) => {
  applyLanguage((lng || "").split("-")[0] || "en");
});

export default i18n;
